import { render, staticRenderFns } from "./DafuerStehenWir.vue?vue&type=template&id=40858aa8&scoped=true&"
import script from "./DafuerStehenWir.vue?vue&type=script&lang=js&"
export * from "./DafuerStehenWir.vue?vue&type=script&lang=js&"
import style0 from "./DafuerStehenWir.vue?vue&type=style&index=0&id=40858aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40858aa8",
  null
  
)

export default component.exports